import { useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getComplexResourceGroups } from 'redux/selectors/experience';
import DrawerLayout from '../drawer_layout';
import { ExperienceContext, searchForBookable } from '../helpers';
import ComplexOptionCard from './complex_option_card';

const ComplexReturnCoach = () => {
  const history = useHistory();
  const { setReturnCoach, needUserSelect, setNeedUserSelect } =
    useContext(ExperienceContext);
  const returnCoach = useSelector((state) =>
    getComplexResourceGroups(state, {
      journeyType: 'return',
    })
  );

  // If we add `returnCoach` to the dependency array, it will cause infinite loop
  // Try to add it then run `$ yarn jest assets/ecom-engine-react/storyshots.test.js --coverage --updateSnapshot`
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const actualReturns = useMemo(() => searchForBookable(returnCoach), []);

  useEffect(() => {
    // If has 1 return coach, use that return coach and goto booking form page
    if (actualReturns.length === 1) {
      setReturnCoach(actualReturns[0]);
      setTimeout(() => history.push('/booking-form'));
    } else {
      setNeedUserSelect((prevState) => ({
        ...prevState,
        returnCoach: true,
      }));
    }
  }, [actualReturns, setReturnCoach, history, setNeedUserSelect]);

  // If has 0 return, display nothing
  if (actualReturns.length === 0) {
    return null;
  }

  return (
    <DrawerLayout
      back={
        needUserSelect.departureFerry ||
        needUserSelect.returnFerry ||
        needUserSelect.departureCoach
      }
      productName={returnCoach[0].title}
    >
      {returnCoach.map((resourceGroup) => (
        <div key={resourceGroup.title}>
          {resourceGroup.options.map((optionGroup) =>
            optionGroup.resourceTitle ? (
              <ComplexOptionCard
                key={optionGroup.key}
                title={optionGroup.title}
                onClick={() => {
                  setReturnCoach(optionGroup);
                  setTimeout(() => history.push('/booking-form'));
                }}
              />
            ) : (
              <div key={optionGroup.title}>
                <h5 className="fw-bold my-4">{optionGroup.title}</h5>
                {optionGroup.options.map((option) => (
                  <ComplexOptionCard
                    key={option.key}
                    title={option.title}
                    onClick={() => {
                      setReturnCoach(option);
                      setTimeout(() => history.push('/booking-form'));
                    }}
                  />
                ))}
              </div>
            )
          )}
        </div>
      ))}
    </DrawerLayout>
  );
};

export default ComplexReturnCoach;
